import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { AdminUserActionsTable } from "./table";

export default function AdminUserActions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actions des utilisateurs administrateurs");
  }, []);

  return (
    <Routes>
      <Route index element={<AdminUserActionsTable />} />
    </Routes>
  );
}
